import Vue from "vue";
import Router from "vue-router";
// import Foo from "../components/Foo.vue"
import Product from "../pages/account/product/index.vue";
// import Bar from "../components/Bar.vue"
// import Test from "../components/Test.vue"
import Login from "../pages/login/Loginindex.vue";
// import Nav from "../components/Nav.vue";
import Layout from "../layout/index.vue";
import UserReport from "../pages/userManage/index.vue";
import Extension from "../pages/extension/index.vue";
import PopuManual from "../pages/popu-manual/index.vue";
import Income from "../pages/income/index.vue";
import Summary from "../pages/summary/summaryindex.vue";
import SummaryTest from "../pages/summary_test/summaryindex.vue";
import summaryReportIncome from "../pages/summary/summary-report-income/index.vue";
import AddDimension from "../pages/summary/add-dimension-report/index.vue";
import ReportWarn from "../pages/summary/report-warn/index.vue";
// 新增ROI预测表
import RoiReport from "../pages/summary/report-roi/index.vue"
import Allreport from "../pages/allreport/index.vue";
import AllreportBak from "../pages/allreport-bak/index.vue";

import UserManage from "../pages/account/user-manage/index.vue";
import RoleManage from "../pages/account/role-manage/index.vue";
import PlayManage from "../pages/account/play-manage/index.vue";
// 产品权限分配
import AuthorAssgin from "../pages/general/product-permission/index.vue";
// import LoginLog from "../pages/account/login-log/index.vue";
import ParamSetting from "../pages/account/param-setting/index.vue";
import DeliverySub from "../pages/account/delivery-sub/index.vue";

import HuaweiPage from "../pages/huawei/huaweiPage.vue";
import MonthlyPopu from "../pages/monthly-report/popu/index.vue";
import LT from "../pages/summary/lt-report/ltindex.vue";
import LtPredictReport from "../pages/summary/lt-predict-report/index.vue";
import LtvReport from "../pages/ltvReport/ltvReport.vue";
import PopuTotalReport from "../pages/popuTotalReport/index.vue";

import AllDemensionsReport from "../pages/summary/alldimension-report/index.vue";
import Errorpage from "../pages/ssologin/errorPage";
import LogoutPage from "../pages/ssologin/logoutPage";

import NotFound from "../pages/notFound/index.vue";
import PlatTables from "./platTable";
import NoMenu from "../pages/ssologin/nomenuPage";
Vue.use(Router);
//element-ui 菜单导航冗余报错
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const router = new Router({
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        title: "登录",
      },
    },
    {
      path: "/error",
      name: "error",
      component: Errorpage,
      meta: {
        title: "错误页面",
      },
    },
    {
      path: "/logout",
      name: "logout",
      component: LogoutPage,
      meta: {
        title: "退出登录",
      },
    },
    {
      path: "/nomenu",
      name: "nomenu",
      component: NoMenu,
      meta: {
        title: "暂无菜单权限",
      },
    },
    {
      path: "/",
      // beforeEnter: (to, from, next) => {
      //   if (to.name === "navigation") {
      //     next({ name: "foo" })
      //   }
      // },
      // redirect: () => {
      //   localStorage.setItem("route", "publishmng.html");
      //   return "/publishmng.html";
      // },
      name: "navigation",
      component: Layout,
      children: [
        {
          path: "publishmng.html",
          name: "product",
          component: Product,
          children: [],
          meta: {
            title: "产品管理",
          },
        },
        {
          path: "user_reten_analy.html",
          name: "usermanage",
          component: UserReport,
          children: [],
          meta: {
            title: "用户报表",
          },
        },
        {
          path: "popu.html",
          name: "extension",
          component: Extension,
          children: [],
          meta: {
            title: "推广报表",
          },
        },
        {
          path: "popuManual.html",
          name: "popuManual",
          component: PopuManual,
          children: [],
          meta: {
            title: "推广数据录入",
          },
        },
        {
          path: "incomeReport.html",
          name: "income",
          component: Income,
          children: [],
          meta: {
            title: "收入报表",
          },
        },
        {
          path: "single_dimension_collect.html",
          name: "summaryrecord",
          component: Summary,
          children: [],
          meta: {
            title: "细分维度报表",
          },
        },
        {
          path: "single_dimension_collect_test.html",
          name: "summaryrecordTest",
          component: SummaryTest,
          children: [],
          meta: {
            title: "细分维度(test)",
          },
        },
        {
          path: "summary_report_income.html",
          name: "summaryReportIncome",
          component: summaryReportIncome,
          children: [],
          meta: {
            title: "广告收入报表",
          },
        },
        {
          path: "dimension_report.html",
          name: "adddimensionreport",
          component: AddDimension,
          children: [],
          meta: {
            title: "新增维度报表",
          },
        },
        {
          path: "report_warn.html",
          name: "reportwarn",
          component: ReportWarn,
          children: [],
          meta: {
            title: "监控预警",
          },
        },
        {
          path: "roi_prediction.html",
          name: "roiReport",
          component: RoiReport,
          children: [],
          meta: {
            title: "新增Roi预测表",
          },
        },

        {
          path: "predict_retention.html",
          name: "ltreport",
          component: LT,
          children: [],
          meta: {
            title: "LT预测表",
          },
        },
        {
          path: "predict_ltv.html",
          name: "ltvReport",
          component: LtvReport,
          meta: {
            title: "LTV回收预测表",
          },
        },
        {
          path: "lt_prediction_report.html",
          name: "ltPredictReport",
          component: LtPredictReport,
          meta: {
            title: "LT工具",
          },
        },
        {
          path: "popu_total.html",
          name: "popuTotalReport",
          component: PopuTotalReport,
          meta: {
            title: "投放总表",
          },
        },
        {
          path: "all_dimension_collect.html",
          name: "alldimensionsreport",
          component: AllDemensionsReport,
          children: [],
          meta: {
            title: "全部维度报表",
          },
        },
        {
          path: "totalReport.html",
          name: "allreport",
          component: Allreport,
          children: [],
          meta: {
            title: "总览报表",
          },
        },
        {
          path: "totalReport-bak.html",
          name: "allreportbak",
          component: AllreportBak,
          children: [],
          meta: {
            title: "自定义报表",
          },
        },
        {
          path: "delivery_sub.html",
          name: "deliverySub",
          component: DeliverySub,
          children: [],
          meta: {
            title: "投放主体管理",
          },
        },
        {
          path: "sys_para.html",
          name: "paramsetting",
          component: ParamSetting,
          children: [],
          meta: {
            title: "参数配置",
          },
        },
        {
          path: "users-new.html",
          name: "role",
          component: UserManage,
          children: [],
          meta: {
            title: "用户管理",
          },
        },
        {
          path: "roles-new.html",
          name: "rolemanage",
          component: RoleManage,
          children: [],
          meta: {
            title: "角色管理",
          },
        },
        {
          path: "play_info.html",
          name: "playmanage",
          component: PlayManage,
          children: [],
          meta: {
            title: "玩法管理",
          },
        },
        {
          path: "user_app.html",
          name: "authassign",
          component: AuthorAssgin,
          children: [],
          meta: {
            title: "产品权限分配",
          },
        },
        // {
        //   path: "login_log.html",
        //   name: "loginLog",
        //   component: LoginLog,
        //   children: [],
        // },
        {
          path: "huawei.html",
          name: "HuaweiReport",
          component: HuaweiPage,
          children: [],
          meta: {
            title: "华为报表",
          },
        },
        {
          path: "monthly_popu.html",
          name: "MonthlyPop0",
          component: MonthlyPopu,
          children: [],
          meta: {
            title: "管理推广报表",
          },
        },

        {
          path: "ads",
          name: "ads",
          component: () =>
            import("../pages/account/account-management/index.vue"),
          children: [
            {
              path: "google.html",
              name: "adsGoogle",
              component: () =>
                import("../pages/account/account-management/google"),
              meta: {
                title: "Google账号管理",
              },
            },
            {
              path: "toutiao.html",
              name: "adsToutiao",
              component: () =>
                import("../pages/account/account-management/toutiao"),
              meta: {
                title: "今日头条账号管理",
              },
            },
            {
              path: "kuaishou.html",
              name: "adsKuaishou",
              component: () =>
                import("../pages/account/account-management/kuaishou"),
              meta: {
                title: "快手账号管理",
              },
            },
            {
              path: "gdt.html",
              name: "adsGdt",
              component: () =>
                import("../pages/account/account-management/gdt"),
              meta: {
                title: "广点通账号管理",
              },
            },
          ],
        },

        // BI看板
        {
          path: "biboard.html",
          name: "biBoard",
          component: () => import("../pages/bi-board/index.vue"),
          meta: {
            title: "BI看板",
          },
        },
        // {
        //   path: "promotion.html",
        //   name: "promotion",
        //   component: () => import("../pages/promotion/index.vue"),
        //   redirect: "promotion.html/proTable",
        //   children: [
        //     {
        //       path: "proTable",
        //       name: "proTable",
        //       component: () => import("../pages/promotionReport/tableIndex.vue"),
        //     },
        //     {
        //       path: "plan",
        //       name: "plan",
        //       component: () => import("../pages/promotion/plan.vue"),
        //     },
        //     {
        //       path: "preview",
        //       name: "preview",
        //       component: () => import("../pages/promotion/preview.vue"),
        //     },
        //   ],
        // },
        {
          path: "promotion.html",
          name: "proTable",
          component: () => import("../pages/promotionReports/index.vue"),
          meta: {
            title: "推广",
          },
        },
        //头条
        {
          path: "promotion.html/plan",
          name: "toutiaoPlan",
          component: () => import("../pages/promotion/plan.vue"),
          meta: {
            title: "头条创建计划",
          },
        },
        //头条
        {
          path: "promotion-ttV2.html/plan",
          name: "toutiaoPlan",
          component: () => import("../pages/promotion-ttV2/plan.vue"),
          meta: {
            title: "头条2.0创建计划",
          },
        },
        {
          path: "promotion-ttV2.html/preview",
          name: "ttV2Perview",
          component: () => import("../pages/promotion-ttV2/preview.vue"),
          meta: {
            title: "头条2.0预览",
          },
        },
        //头条
        {
          path: "promotion-google.html/plan",
          name: "googlePlan",
          component: () => import("../pages/promotion-google/plan.vue"),
          meta: {
            title: "Google创建计划",
          },
        },
        {
          path: "promotion-google.html/preview",
          name: "googlePerview",
          component: () => import("../pages/promotion-google/preview.vue"),
          meta: {
            title: "Google预览",
          },
        },
        {
          path: "promotion.html/preview",
          name: "toutiaoPreview",
          component: () => import("../pages/promotion/preview.vue"),
          meta: {
            title: "头条预览",
          },
        },
        //快手
        {
          path: "kuaishou/plan",
          name: "kuaishouPlan",
          component: () => import("../pages/promotion-kuaishou/plan.vue"),
          meta: {
            title: "快手创建计划",
          },
        },
        {
          path: "kuaishou/preview",
          name: "kuaishouPreview",
          component: () => import("../pages/promotion-kuaishou/preview.vue"),
          meta: {
            title: "快手预览",
          },
        },
        //广点通
        {
          path: "gdt/plan",
          name: "gdtPlan",
          component: () => import("../pages/promotion-gdt/plan.vue"),
          meta: {
            title: "广点通创建计划",
          },
        },
        {
          path: "gdt/preview",
          name: "gdtPreview",
          component: () => import("../pages/promotion-gdt/preview.vue"),
          meta: {
            title: "广点通预览",
          },
        },
        {
          path: "report.html",
          name: "report",
          component: () => import("../pages/report/index.vue"),
          meta: {
            title: "报表",
          },
        },
        // 工具
        {
          path: "data_screen.html",
          name: "dataTotal",
          component: () => import("../pages/tools/dataTotal/index.vue"),
          children: [],
          meta: {
            title: "数据总览",
          },
        },
        {
          path: "track_manage.html",
          name: "trackManage",
          component: () => import("../pages/tools/trackManage/index.vue"),
          children: [],
          meta: {
            title: "追踪管理",
          },
        },
        {
          path: "channel_config.html",
          name: "channelConf",
          component: () => import("../pages/tools/channelConf/index.vue"),
          children: [],
          meta: {
            title: "渠道配置",
          },
        },
        {
          path: "custom_links.html",
          name: "customLink",
          component: () => import("../pages/tools/customLink/index.vue"),
          children: [],
          meta: {
            title: "自定义链接",
          },
        },
        {
          path: "retention_report.html",
          name: "retainedReport",
          component: () => import("../pages/tools/retainedReport/index.vue"),
          children: [],
          meta: {
            title: "留存报告",
          },
        },
        {
          path: "attribution_product_manage.html",
          name: "productManage",
          component: () => import("../pages/tools/productManage/index.vue"),
          children: [],
          meta: {
            title: "归因产品管理",
          },
        },
        {
          path: "material_create.html",
          name: "materialCreate",
          component: () =>
            import("../pages/material-manage/material-create/index.vue"),
          meta: {
            title: "素材制作信息",
          },
        },
        {
          path: "material_testinfo_syn.html",
          name: "materialSync",
          component: () =>
            import("../pages/material-manage/material-sync/index.vue"),
          meta: {
            title: "素材测试信息同步",
          },
        },
        {
          path: "popu_info_record.html",
          name: "popuInfoRecord",
          component: () => import("../pages/popu-manage/info-record/index.vue"),
          meta: {
            title: "投放信息记录",
          },
        },
        {
          path: "product_popu_query.html",
          name: "ProPopuQuery",
          component: () =>
            import("../pages/popu-manage/product-query/index.vue"),
          meta: {
            title: "产品投放查询",
          },
        },
        {
          path: "lt_check.html",
          name: "ltCheck",
          component: () => import("../pages/lt-check/index.vue"),
          meta: {
            title: "LT校验表",
          },
        },
      ].concat(PlatTables, [
        {
          path: "*",
          name: "notFound",
          component: NotFound,
          meta: {
            title: "404页面",
          },
        },
      ]),
    },
  ],
});

router.beforeEach((to, from, next) => {
  // to 及将要进入的目标的路由对象
  // from 当前导航即将离开的路由对象
  // next 调用该方法后，才能进入下一个钩子
  if (!from.name && to.name == "404") {
    next();
    router.push("/login");
  } else {
    if (to.name == "login") {
      next();
    }
    //登录成功之后就可以进入页面
    if (to.name !== "login") {
      next();
    } else {
      next({ name: "login" });
    }
  }
});

export default router;
